import React from "react";
import { Box, CardContent, Grid, Paper, Typography } from "@mui/material";
import SyncAltRoundedIcon from "@mui/icons-material/SyncAltRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import LightbulbRoundedIcon from "@mui/icons-material/LightbulbRounded";
import { ServiceOptionCard } from "../../styles/StyledComponents";

function Step1Profile({ formData, errors, handleChange }) {
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
        <SyncAltRoundedIcon color="primary" />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Hai cambiato più di 2 fornitori negli ultimi 12 mesi?
        </Typography>
      </Box>

      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6}>
          <ServiceOptionCard
            selected={formData.cambiatoFornitori === "si"}
            onClick={() => handleChange("cambiatoFornitori", "si")}
          >
            <CardContent sx={{ textAlign: "center", py: 3 }}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Sì
              </Typography>
            </CardContent>
          </ServiceOptionCard>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ServiceOptionCard
            selected={formData.cambiatoFornitori === "no"}
            onClick={() => handleChange("cambiatoFornitori", "no")}
          >
            <CardContent sx={{ textAlign: "center", py: 3 }}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                No
              </Typography>
            </CardContent>
          </ServiceOptionCard>
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
        <GroupRoundedIcon color="primary" />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Quante persone vivono in casa?
        </Typography>
      </Box>

      <Grid container spacing={2} sx={{ mb: 4 }}>
        {["1", "2", "3", "4", "5+"].map((numero) => (
          <Grid item xs={6} sm={2.4} key={numero}>
            <ServiceOptionCard
              selected={formData.personeInCasa === numero}
              onClick={() => handleChange("personeInCasa", numero)}
            >
              <CardContent sx={{ textAlign: "center", py: 3 }}>
                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                  {numero}
                </Typography>
              </CardContent>
            </ServiceOptionCard>
          </Grid>
        ))}
      </Grid>

      <Paper
        elevation={0}
        sx={{
          p: 3,
          bgcolor: "info.lighter",
          borderRadius: 2,
          border: 1,
          borderColor: "info.light",
        }}
      >
        <Box sx={{ display: "flex", gap: 2 }}>
          <LightbulbRoundedIcon sx={{ color: "info.main", flexShrink: 0 }} />
          <Box>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, mb: 1, color: "info.dark" }}
            >
              💡 Perché chiediamo queste informazioni?
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Questi dati ci aiutano a trovare l'offerta più adatta al tuo
              consumo effettivo.
            </Typography>
          </Box>
        </Box>
      </Paper>

      {(errors.cambiatoFornitori || errors.personeInCasa) && (
        <Typography
          variant="caption"
          color="error"
          sx={{ mt: 2, display: "block" }}
        >
          Completa tutti i campi per continuare
        </Typography>
      )}
    </Box>
  );
}

export default Step1Profile;
